import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useContext } from "react"
import { View } from "react-native"
import { connect } from "react-redux"
import plantTree from "../../../assets/icons/generic/candidat.png"
import ChampionBubble from "../../student/champions/ChampionBubble"

const ApplicationFinishedScreen = (props) => {
    const dimensions = useContext(DimensionsContext)

    const text =
        props.user?.candidature_status === "pending"
            ? "Merci ! \nNous étudions ta candidature. En général, nous envoyons une réponse en quelques semaines."
            : "Tu as reçu un email avec ton évaluation."
    const variant =
        props.user?.candidature_status === "rejected" ? "main" : "happy"

    return (
        <View
            style={{
                alignItems: "center",
                justifyContent: "center",
                width: dimensions?.width,
                alignSelf: "center",
                flex: 1,
            }}
        >
            <TextM
                color={theme.colors.primary}
                fontWeight={"Bold"}
                fontSize={20}
            >
                CANDIDATURE TERMINÉE !
            </TextM>
            <View>
                <IconImageM
                    source={plantTree}
                    width={100}
                    style={{ borderRadius: 15, marginTop: 10 }}
                />
            </View>
            <ChampionBubble
                name={"zoe"}
                variant={variant}
                championPosition="center"
                texts={[text]}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getUserRequest: state.api.getUser?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApplicationFinishedScreen)
